export const mobileChecker = ( val = '' ) => {
  let tempVal = val.length > 0 && val[0] !== '+'
    ? `+${ val }`
    : val
  
  return tempVal;
}